import React from 'react';
import { useKatalFeatureFlag } from 'libs/hooks/useKatalFeatureFlag';
import WorkOrderTabsAntD, { WorkOrderTabsProps } from './component-antd';
import WorkOrderTabsKatal from './component-katal';

const WorkOrderTabs = (props: WorkOrderTabsProps) => {
  const useKatal = useKatalFeatureFlag(props.recordType);

  return useKatal ? (
    <WorkOrderTabsKatal {...props} />
  ) : (
    <WorkOrderTabsAntD {...props} />
  );
};

export default WorkOrderTabs;
export type { WorkOrderTabsProps };
